import { StrichSDK } from '@pixelverse/strichjs-sdk';
import { setLicenseKey } from 'survey-core';

export async function initVendorLicenses(): Promise<void> {
  // Initialize vendor licenses here
  setLicenseKey(import.meta.env.VITE_SURVEY_KEY); // Example: LicenseManager.setLicenseKey('your-license-key');
  await StrichSDK.initialize(import.meta.env.VITE_STRICH_API_KEY); // Example: LicenseManager.setLicenseKey('your-license-key');
}
